import { useNavigate } from 'react-router-dom';
import { Globals as OldGlobals } from '../../global/Globals';
import axios from '../../services/axiosInstance';
import { validateSocialMediaLinks } from '../../util/util';
import { useLanguage } from '../../context/Languagecontext';
const { useEffect, useState } = require("react");
let producerId=OldGlobals.producerId;

const ReviewProposalHooks = ({
    proposalId,
    proposalDetailId,
    commentsInput,
    criteria,
    inputValues,
    selectedProposal,
    finalScore
}) => {
    const {Globals}=useLanguage();
    const [errors, setErrors] = useState({});
    const [loading,setLoading]=useState(false);
    const [touched, setTouched] = useState({});
    //const [isDraftStatus, setIsDraftStatus]=useState();
    const [popUpState, setPopUpState] = useState({
        open: false,
        title: '',
        text: '',
        negativeAction:null,
        normalAction:null,
        negativeActionText:'',
        normalActionText:'',
    });
    const navigate = useNavigate();
    const gotoMyProposals = (success=false) => {
        console.log("succ", success)
        if(success){
            if (localStorage.getItem('isDraft')) {
                navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", success, isCEReviewdraft:true, selectedTab: selectedProposal } })
            }
            else {
                navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", success, selectedTab: selectedProposal } })
            }
            return;
        }
        navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", success:true,draft:false, discard:true, selectedTab: selectedProposal}})
        // navigate(Globals.NAVPATH.HOME+"?activeHeader=proposals");
    }

    const openProposalReviewPopUp = (popUpType="Submit",updateFlag=false) => {
        console.log("Popup type = "+popUpType)
        if(popUpType === "Abort"){
            setPopUpState({
                open: true,
                title: Globals.ABORT_PROPOSAL_PROMPT_TITLE,
                text: Globals.ABORT_PROPOSAL_PROMPT,
                negativeAction: gotoMyProposals,
                negativeActionText: Globals.ABORT,
            });
            return;
        }

        if(popUpType === "Submit"){
            const newErrors = {};
            let hasError = false;
         
            criteria?.forEach((item) => {
              const error = validateFields(item.criteriaId, inputValues[item.criteriaId]);
              if (error) {
                newErrors[item.criteriaId] = error;
                hasError = true;
              }
            });
         
            setErrors(newErrors);
            setTouched((prev) => {
              const updatedTouched = { ...prev };
              criteria?.forEach((item) => {
                if (newErrors[item.criteriaId]) updatedTouched[item.criteriaId] = true;
              });
              return updatedTouched;
            });
         
            if (!hasError) {

                setPopUpState({
                    open: true,
                    title: Globals.REVIEW_PROPOSALS.SUBMIT_REVIEW_PROPOSAL,
                    text: Globals.REVIEW_PROPOSALS.SUBMIT_REVIEW_PROPOSAL_DESC,
                    normalAction: submitUnsolicitedReviewProposal,
                    normalActionText: Globals.REVIEW_PROPOSALS.SUBMIT_REVIEW,
                });
            }
            localStorage.removeItem("isDraft");

        } else if(popUpType === "proposal_review_failed"){
            setPopUpState({
                open: true,
                title: Globals.REVIEW_PROPOSALS.REVIEW_SUBMISSION_FAILED,
                text: Globals.REVIEW_PROPOSALS.REVIEW_SUBMISSION_FAILED_DESC,
                normalAction: submitUnsolicitedReviewProposal,
                normalActionText: Globals.REVIEW_PROPOSALS.RETRY_SUBMISSION,
                remove_cancel_btn: true
            });
        }
        else if(popUpType === "Draft"){
            localStorage.setItem('isDraft',true);
                setPopUpState({
                    open: true,
                    title: Globals.CE_EVAL_SAVE_AS_DRAFT_POPUP_TITLE,
                    text: Globals.CE_EVAL_SAVE_AS_DRAFT_POPUP_MESSAGE,
                    normalAction: submitUnsolicitedReviewProposal,
                    normalActionText: Globals.CE_EVAL_SAVE_AS_DRAFT_BUTTON_TEXT,
                });
        }
        else if (popUpType === "draft_failed") {
            setPopUpState({
                open: true,
                title: Globals.CE_EVAL_SAVE_AS_DRAFT_ERROR_POPUP_TITLE,
                text: Globals.CE_EVAL_SAVE_AS_DRAFT_ERROR_POPUP_MSG,
                normalAction: submitUnsolicitedReviewProposal,
                normalActionText: Globals.REVIEW_PROPOSALS.RETRY_SUBMISSION,
                remove_cancel_btn: true
            });
        }
    }

    const validateFields = (id, value) => {
        const num = parseFloat(value);
        if (value === "" || isNaN(num)) return Globals.REVIEW_PROPOSALS.VALIDATION_ERROR
        return "";
    }



    const submitUnsolicitedReviewProposal = async () => {

        const finalData = criteria?.map((criteria) => ({
            gradeValue : parseInt(inputValues[criteria.criteriaId]), 
            proposalCriteriaId  : criteria.criteriaId
        }));
        const requestBody = {
            proposalDetailId: proposalDetailId,
            criteriaGradeEvaluations: finalData ? finalData : [],
            comments: commentsInput === "" ? null : commentsInput,
            totalScore: finalScore!='N/A' ? finalScore : 0,
            isDraft: localStorage.getItem('isDraft')?JSON.parse(localStorage.getItem('isDraft')):false
        };

        setLoading(true);
        try {
            const config = {
                headers: {
                  'Content-Type': 'application/json' // Set the Content-Type header
                }
            };
            const response = await axios.post(OldGlobals.ENDPOINT.UNSOLICITED_REVIEW_PROPOSAL,requestBody,config);
            

            setLoading(false);
            if (!response?.data?.status) {
                throw new Error('Network response was not ok');
            }
            if(response.data.status === "OK"){
                gotoMyProposals(true);
            } else {
                if (localStorage.getItem('isDraft')) {
                    openProposalReviewPopUp("draft_failed");
                }
                else {
                    openProposalReviewPopUp("proposal_review_failed");
                }
            }
        } catch (error) {
            setLoading(false);
            if (localStorage.getItem('isDraft')) {
                openProposalReviewPopUp("draft_failed");
            }
            else {
                openProposalReviewPopUp("proposal_review_failed");
            }
            console.error('Error:', error);
            
        }
    };

    const getUnsolicitedProposal = async (propId,load=true)=>{
        setLoading(true);
        try {
            const endpoint =OldGlobals.ENDPOINT.GET_UNSOLICITED_PROPOSAL +"?"+"producerId="+producerId+"&"+"proposalId="+(proposalId || propId) ;
            const response = await axios.get(endpoint);
            

            load && setLoading(false);
            if (!response?.data?.status) {
                throw new Error('Network response was not ok');
            }
            if(response.data.content){
                return response.data.content;
            }
            console.log('Success:');
        } catch (error) {
            load && setLoading(false);
            console.error('Error:', error);
        }
    }
    return { errors,validateFields,popUpState, openProposalReviewPopUp,setPopUpState,setErrors, loading,setLoading, getUnsolicitedProposal, touched, setTouched };
}
export default ReviewProposalHooks;